import React from 'react';
import * as api from '../../../../api/doc'
import PageList from '../../../../components/PageListAPI'
import { useCan } from '../../../../hooks/useCan';
import { SLUGS } from '../../../../enum/permissions.enum';

export default function UseToolList({ match, history, location }) {
  const can = useCan()
  return (
    <div className='App-paper'>
      <PageList
        name='useToolList'
        title='Документы выдачи оборудования работнику'
        columns={[
          { id: 'id', name: '№' },
          { id: 'date', name: 'Дата выдачи', type: 'date' },
          { id: 'inventory', name: 'Оборудование', },
          { id: 'user', name: 'Выдал', },
          { id: 'worker', name: 'Получил', },
          { id: 'position', name: 'Должность', },
        ].filter(key => key)}
        createItem={can(SLUGS.PROJECT.TOOL_UW.USE_MANAGE)}
        deleteItem={can(SLUGS.PROJECT.TOOL_UW.USE_MANAGE)}
        idName='id'
        history={history}
        match={match}
        location={location}
        loadAPI={{
          param: {
            id: match.params.idProject
          },
          request: api.getUseTool,
          transform: (res => {
            return {
              count: res.count,
              get: res.get.map(obj => {
                return {
                  id: obj.id,
                  date: obj.date,
                  user: obj.gSurname + ' ' + obj.gName,
                  worker: obj.surname + ' ' + obj.name[0] + '.' + obj.patronymic[0] + '.',
                  position: obj.position,
                  inventory: obj.inventoryNumber.toString().padStart(5, '0') + ' ' + obj.inventoryName,
                  writeOff: obj.writeOff,
                }
              })
            }
          }),
        }}
        deleteAPI={api.deleteUseToolById(match.params.idProject)}
        disabledDelete={(obj) => !obj.writeOff}
        headerInit={{
          sortBy: 'date',
          sortDirection: 'desc',
        }}
      />
    </div>
  )
};


